import { useState } from 'react';
import { CreateDialog } from './CreateDialog';
import { FinishedDialog } from './FinishedDialog';
export function AddCompanyDialog(props) {
    const { onClose } = props;
    const [createdAccountId, setCreatedAccountId] = useState(null);
    if (!createdAccountId) {
        return <CreateDialog onClose={onClose} onCreate={setCreatedAccountId}/>;
    }
    return <FinishedDialog accountId={createdAccountId}/>;
}
